import { useEffect } from 'react';
import { useState } from 'react';

import { CarouselApi } from '@/shared/ui';

interface IUseInitSliderApi {
  setActiveSlide?: (activeSlide: number) => void;
}

export const useInitSliderApi = ({
  setActiveSlide,
}: IUseInitSliderApi = {}) => {
  const [api, setApi] = useState<CarouselApi | null>(null);

  useEffect(() => {
    if (!api) return;

    const onSelect = () => {
      setActiveSlide?.(api.selectedScrollSnap());
    };

    api.on('select', onSelect);

    return () => {
      api.off('select', onSelect);
    };
  }, [api]);

  return {
    api,
    setApi,
  };
};
